export abstract class UserConst {

    /**
     * The API prefix for the Users API
     * @readonly
     * @type {string}
     */
    public static readonly AUTH_API_PREFIX = 'users';

    /**
     * The endpoint to get user info
     * @returns {string} The endpoint to get user info
     * @example
     * ```typescript
     * const endpoint = UserConst.GET_USER_INFO_ENDPOINT;
     * console.log(endpoint); // {{baseUrl}}/api/v1/users/userinfo
     * ```
     */
    public static readonly GET_USER_INFO_ENDPOINT = `${UserConst.AUTH_API_PREFIX}/userinfo`;

    /**
     * The endpoint to request a password reset email
     * @returns {string} The endpoint to request a password reset email
     * @example
     * ```typescript
     * const endpoint = UserConst.FORGOT_PASSWORD_ENDPOINT;
     * console.log(endpoint); // {{baseUrl}}/api/v1/users/forget_password
     * ```
     */
    public static readonly FORGOT_PASSWORD_ENDPOINT = `${UserConst.AUTH_API_PREFIX}/forget_password`;

    /**
     * 
     * The endpoint to reset the password
     * @returns {string} The endpoint to reset the password
     * 
     * @example
     * ```typescript
     * const endpoint = UserConst.RESET_PASSWORD_ENDPOINT;
     * console.log(endpoint); // {{baseUrl}}/api/v1/users/reset_password
     * ```
     */
    public static readonly RESET_PASSWORD_ENDPOINT = `${UserConst.AUTH_API_PREFIX}/reset_password`;

    /**
     * Endpoint to check if a reset token is valid
     * @param token - The reset token to check
     * @returns {string} The endpoint to check if a reset token is valid
     * @example
     * ```typescript
     * const endpoint = UserConst.CHECK_RESET_TOKEN_ENDPOINT('1234567890');
     * console.log(endpoint); // {{baseUrl}}/api/v1/users/check_reset_token/1234567890
     * ```
     */
    public static readonly CHECK_RESET_TOKEN_ENDPOINT = (token: string): string => `${UserConst.AUTH_API_PREFIX}/check_reset_token/${token}`;
    
    /**
     * The endpoint to get list of roles
     * @returns {string} The endpoint to get list of roles
     * @example
     * ```typescript
     * const endpoint = UserConst.GET_LIST_OF_ROLES_ENDPOINT;
     * console.log(endpoint); // {{baseUrl}}/api/v1/users/register
     * ```
     */
    public static readonly GET_LIST_OF_ROLES_ENDPOINT = `${UserConst.AUTH_API_PREFIX}/register`;
}
